import React, { useState, useEffect, useRef } from "react";
import { AsYouType } from "libphonenumber-js";

const PhoneNumberInputV2 = ({
  value = "",
  onChange,
  onEnter,
  disabled,
  style,
}) => {
  const input = useRef();
  const focus = () => input.current.focus();
  const [formattedValue, setFormattedValue] = useState("");

  const handleChange = (val) => {
    const asYouType = new AsYouType("US");
    const formatted = asYouType.input(val);
    onChange(val, asYouType.getNumber());

    // remove braces when appropriate
    if (val.length <= 5 && val[0] === "(" && val[val.length - 1] !== ")") {
      const lastCursorPosition = input.current.selectionEnd;
      setFormattedValue(formatted.replace("(", "").replace(")", ""));
      input.current.selectionEnd = lastCursorPosition;
      return;
    }
    // Ignore invalid patterns, allow deleting last character
    if (!asYouType.getTemplate() && val.length > 0) {
      return;
    }

    setFormattedValue(formatted);
  };

  // Focus the field on load
  useEffect(() => {
    focus();
    if (value) {
      handleChange(value);
    }
  }, []);

  return (
    <div className="inline-block">
      <span className="inline-block text-xl md:text-2xl">+1</span>{" "}
      <input
        type="text"
        pattern="[0-9]*"
        inputMode="numeric"
        placeholder="(000) 000-0000"
        value={formattedValue}
        style={style}
        className="bg-transparent py-2 border-b-2 text-2xl text-center border-gray-500 outline-none phone-input inline-block w-9/12"
        maxLength={15}
        onChange={(e) => handleChange(e.target.value)}
        onKeyUp={(e) => {
          const [v, k] = [e.target.value, e.key];
          const p = v.length - 1;
          // Move to cursor inside the braces after deleting
          // the first character after the braces
          if (k === "Backspace" && v[p] === ")") {
            focus();
            input.current.setSelectionRange(p, p);
          }
          if (k === "Enter") {
            onEnter(v);
          }
        }}
        ref={input}
        disabled={disabled}
      />
    </div>
  );
};

export default PhoneNumberInputV2;